import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

import { AuthProvider, useAuth } from "../admin/AuthContext";
import LoginPage from "../admin/LoginPage";
import AdminShell from "../admin/AdminShell";
import DashboardOverview from "../admin/DashboardOverview";
import CRMModule from "../admin/CRMModule";
import InventoryModule from "../admin/InventoryModule";
import ShopModule from "../admin/ShopModule";
import QuotationsModule from "../admin/QuotationsModule";
import ProjectsModule from "../admin/ProjectsModule";
import CmsModule from "../admin/CmsModule";

import "../admin/admin.css";

function Loader({ label = "Booting…" }) {
  return (
    <div
      className="min-h-screen flex items-center justify-center"
      data-testid="admin-boot-loader"
    >
      <div className="text-xs tracking-[0.32em] uppercase" style={{ color: "var(--ax-text-muted)" }}>
        {label}
      </div>
    </div>
  );
}

function RequireAuth({ children }) {
  const { user, booting } = useAuth();
  const loc = useLocation();
  if (booting) return <Loader />;
  if (!user) {
    return <Navigate to="/admin-dashboard/login" replace state={{ from: loc.pathname }} />;
  }
  return children;
}

function GuestOnly({ children }) {
  const { user, booting } = useAuth();
  if (booting) return <Loader />;
  if (user) return <Navigate to="/admin-dashboard" replace />;
  return children;
}

function AdminRoutes() {
  return (
    <Routes>
      <Route
        path="login"
        element={
          <GuestOnly>
            <LoginPage />
          </GuestOnly>
        }
      />
      <Route
        path="/*"
        element={
          <RequireAuth>
            <AdminShell>
              <Routes>
                <Route index element={<DashboardOverview />} />
                <Route path="crm" element={<CRMModule />} />
                <Route path="inventory" element={<InventoryModule />} />
                <Route path="shop" element={<ShopModule />} />
                <Route path="quotations/*" element={<QuotationsModule />} />
                <Route path="projects" element={<ProjectsModule />} />
                <Route path="website-content" element={<CmsModule />} />
                <Route path="*" element={<Navigate to="." replace />} />
              </Routes>
            </AdminShell>
          </RequireAuth>
        }
      />
    </Routes>
  );
}

export default function AdminDashboard() {
  return (
    <div className="gx-admin" data-testid="admin-root">
      <div className="ax-grain" />
      <AuthProvider>
        <AdminRoutes />
      </AuthProvider>
    </div>
  );
}
